// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/puntero.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
   /* cursor: crosshair; */
   cursor:url(${___CSS_LOADER_URL_REPLACEMENT_0___}), auto
}
.cursor {
  background-color: rgba(229, 255, 0, 0);
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 2px solid #000;
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 2;
}




#light .Portfolio{background: #000;}

.latest{font-size: 43px; 
  line-height: 33px;
    font-family: 'Bebas Neue'
  }

  #dark .latest{font-size: 43px; 
    line-height: 33px; color: #000;text-shadow: 1px 1px #ffffffb9;  }

#dark .cursor {
  background-color: rgba(251, 255, 0, 0.692); border: none;}


#dark{
  border-top: 5px solid  rgb(45, 246, 253);
    background: 
    linear-gradient(7deg, rgba(255, 255, 255, 1) 55%, rgb(7 7 46 / 31%) 95%);
  
    color: #FFF;
    }
#dark p {color:rgb(0, 0, 0); text-shadow: 1px 1px #ffffff4f;}

#light{
    border-top: 5px solid #000;
    background:     
linear-gradient(7deg, rgba(255,255,255,1)  79%, rgba(213,253,45,1) 95%);
  
 ;
    color: rgb(0, 0, 0);
}

h1{font-family: 'Bebas Neue', cursive;}
h2{ font-family: 'Rubik', sans-serif;}
p {
  font-family: 'Rubik', sans-serif;
}
a {
  font-family: 'Rubik', sans-serif;
}
.seeMore{font-size: 27px ;
  font-family: 'Bebas Neue', cursive;
color:#FFF;
background: #000;
border-radius: 3px;
padding: 3px 51px; width: -moz-fit-content; width: fit-content;
width: fit-content;
margin: 5% auto 0 auto;
cursor: help;
text-decoration: none;}


.gridbox {
    text-align: center;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 5%;

  }
  
  .cantv{cursor: pointer;}
  .cantvWrap {
      height: 55px;
      color: rgba(0, 0, 0, 0.577);
      width: 193px;
      padding: 0!important;
      margin: 0!important;   
      line-height: 57px; 
      font-size: 15px;
      font-family: 'Bebas Neue';
       z-index: 999;
       position: absolute;
      
    }

  
      .one {
        background-color: rgb(255, 255, 255);
        max-width: 655px;
        width: -moz-fit-content;
        width: fit-content;
        /* margin-left: 3%; */
        margin-top: 3%;
        padding: 25px;
        border-radius: 11px;
        margin: 0 auto;}

.head{background: rgba(233, 30, 172, 0.7);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
margin-top: 3%; right: 5%; max-width: 271px; padding: 29px; border-radius: 7px;}

a { text-decoration: none;cursor: pointer;}

.back:hover{cursor: pointer;color: #000000; background: #ffffff;}
.back{cursor: pointer;color: #FFF; background: #000;
padding: 3px; width: 111px; margin-bottom: 9%;
padding: 3%;}

.mapImg{
  max-width: 100%; height: auto;
}

.link{ padding: 10px 0; margin-top: 9px;}
.link a{cursor: pointer; color: #FFF; background: #000; font-size: 15px;
padding: 5px 15px;}
.link a:hover{ color: #000000; background: #ffffff; font-size: 15px;
padding: 5px 15px;}

  /* Button Filters */
  .button-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 13px;
    margin: 5% auto 3% auto;
    flex-direction: row;
  }
  .buttonFilter > button:hover{
    
    transition: all 1s ease;
    color:rgba(0, 195, 255, 0.966)} 

 #dark .buttonFilter button {color: #FFF}
  .buttonFilter button {
    height: 2rem;
    padding: 0 1rem;
    cursor: pointer;
    border: none;
    background: none;
    color:rgb(0, 0, 0);
    font-size: 17px;
    
  }
  
  .buttonFilter > button.active {
    background: rgb(0, 0, 0);
    color: white;
    border-radius: 5px;
    border-bottom: 1px solid #40f4fd;
  }
  
  /* Image */

.img-graph { 
  display: grid;
  /* grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr)); */
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-top: 2rem;mix-blend-mode:multiply}


  #dark .image-container {mix-blend-mode:multiply}

  .image-container__two {
    display: grid;
    width: 80%;
    margin: 0 auto 5% auto;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    margin-top: 2rem;mix-blend-mode:multiply
    
  }
  .image-container {
    display: grid;
    /* grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr)); */
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    margin-top: 2rem;
    /* mix-blend-mode:multiply */
    background: #fff;
    border-radius: 17px;
  
    padding: 3%;
  }
  .image-container > .image-card {
    color: white;
    border-radius: 5px;
    position: relative;
    height: auto;
    width:auto;
  }

 
  
  .image-card img:hover  {
    transform:  scale(0.9);
  }
  .image-card img {
    width: 100%;
    
    object-fit: cover;
    transition: all 1s ease;
  }



  .image-card h2 {
    position: relative;
    bottom: 0;
    left: 1rem;
    font-size: 1rem;
 color: #000;
 margin-bottom: 33px;
 text-align: left;
  }



  
  @media screen and (max-width: 971px) {
    .cantvWrap { display: none }
  }
  
  @media screen and (max-width:1301px) {
    
    .one{background-color: rgb(255, 255, 255);
      max-width: 655px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: 3%;
      margin-top: 3%;
      padding: 25px;
      border-radius: 11px;} 
    }
    @media screen and (max-width: 571px) {
      .image-container {
        grid-template-columns: repeat(1, 1fr);}
    }`, "",{"version":3,"sources":["webpack://./src/App_style.css"],"names":[],"mappings":";AACA;GACG,uBAAuB;GACvB;AACH;AACA;EACE,sCAAsC;EACtC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,UAAU;AACZ;;;;;AAKA,kBAAkB,gBAAgB,CAAC;;AAEnC,QAAQ,eAAe;EACrB,iBAAiB;IACf;EACF;;EAEA,cAAc,eAAe;IAC3B,iBAAiB,EAAE,WAAW,CAAC,8BAA8B,GAAG;;AAEpE;EACE,0CAA0C,EAAE,YAAY,CAAC;;;AAG3D;EACE,wCAAwC;IACtC;4EACwE;;IAExE,WAAW;IACX;AACJ,SAAS,kBAAkB,EAAE,8BAA8B,CAAC;;AAE5D;IACI,0BAA0B;IAC1B;uEACmE;;;IAGnE,mBAAmB;AACvB;;AAEA,GAAG,kCAAkC,CAAC;AACtC,IAAI,gCAAgC,CAAC;AACrC;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA,SAAS,gBAAgB;EACvB,kCAAkC;AACpC,UAAU;AACV,gBAAgB;AAChB,kBAAkB;AAClB,iBAAiB,EAAE,uBAAkB,EAAlB,kBAAkB;AACrC,kBAAkB;AAClB,sBAAsB;AACtB,YAAY;AACZ,qBAAqB,CAAC;;;AAGtB;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;;EAEf;;EAEA,OAAO,eAAe,CAAC;EACvB;MACI,YAAY;MACZ,2BAA2B;MAC3B,YAAY;MACZ,oBAAoB;MACpB,mBAAmB;MACnB,iBAAiB;MACjB,eAAe;MACf,yBAAyB;OACxB,YAAY;OACZ,kBAAkB;;IAErB;;;MAGE;QACE,oCAAoC;QACpC,gBAAgB;QAChB,uBAAuB;QACvB,kBAAkB;QAClB,qBAAqB;QACrB,cAAc;QACd,aAAa;QACb,mBAAmB;QACnB,cAAc,CAAC;;AAEvB,MAAM,mCAAmC;EACvC,kCAA0B;UAA1B,0BAA0B;AAC5B,cAAc,EAAE,SAAS,EAAE,gBAAgB,EAAE,aAAa,EAAE,kBAAkB,CAAC;;AAE/E,IAAI,qBAAqB,CAAC,eAAe,CAAC;;AAE1C,YAAY,eAAe,CAAC,cAAc,EAAE,mBAAmB,CAAC;AAChE,MAAM,eAAe,CAAC,WAAW,EAAE,gBAAgB;AACnD,YAAY,EAAE,YAAY,EAAE,iBAAiB;AAC7C,WAAW,CAAC;;AAEZ;EACE,eAAe,EAAE,YAAY;AAC/B;;AAEA,OAAO,eAAe,EAAE,eAAe,CAAC;AACxC,QAAQ,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,eAAe;AACvE,iBAAiB,CAAC;AAClB,eAAe,cAAc,EAAE,mBAAmB,EAAE,eAAe;AACnE,iBAAiB,CAAC;;EAEhB,mBAAmB;EACnB;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;EACrB;EACA;;IAEE,uBAAuB;IACvB,8BAA8B;;CAEjC,4BAA4B,WAAW;EACtC;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;;EAEjB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA,UAAU;;AAEZ;EACE,aAAa;EACb,kEAAkE;EAClE,qCAAqC;EACrC,SAAS;EACT,gBAAgB,CAAC,uBAAuB;;;EAGxC,wBAAwB,uBAAuB;;EAE/C;IACE,aAAa;IACb,UAAU;IACV,sBAAsB;IACtB,qCAAqC;IACrC,SAAS;IACT,gBAAgB,CAAC;;EAEnB;EACA;IACE,aAAa;IACb,kEAAkE;IAClE,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;;IAEnB,WAAW;EACb;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;;;;EAIA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;;IAEX,iBAAiB;IACjB,uBAAuB;EACzB;;;;EAIA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;CAClB,WAAW;CACX,mBAAmB;CACnB,gBAAgB;EACf;;;;;EAKA;IACE,aAAa,cAAc;EAC7B;;EAEA;;IAEE,KAAK,oCAAoC;MACvC,gBAAgB;MAChB,uBAAkB;MAAlB,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,aAAa;MACb,mBAAmB,CAAC;IACtB;IACA;MACE;QACE,qCAAqC,CAAC;IAC1C","sourcesContent":["\n* {\n   /* cursor: crosshair; */\n   cursor:url(\"./img/puntero.gif\"), auto\n}\n.cursor {\n  background-color: rgba(229, 255, 0, 0);\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  border: 2px solid #000;\n  position: fixed;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  z-index: 2;\n}\n\n\n\n\n#light .Portfolio{background: #000;}\n\n.latest{font-size: 43px; \n  line-height: 33px;\n    font-family: 'Bebas Neue'\n  }\n\n  #dark .latest{font-size: 43px; \n    line-height: 33px; color: #000;text-shadow: 1px 1px #ffffffb9;  }\n\n#dark .cursor {\n  background-color: rgba(251, 255, 0, 0.692); border: none;}\n\n\n#dark{\n  border-top: 5px solid  rgb(45, 246, 253);\n    background: \n    linear-gradient(7deg, rgba(255, 255, 255, 1) 55%, rgb(7 7 46 / 31%) 95%);\n  \n    color: #FFF;\n    }\n#dark p {color:rgb(0, 0, 0); text-shadow: 1px 1px #ffffff4f;}\n\n#light{\n    border-top: 5px solid #000;\n    background:     \nlinear-gradient(7deg, rgba(255,255,255,1)  79%, rgba(213,253,45,1) 95%);\n  \n ;\n    color: rgb(0, 0, 0);\n}\n\nh1{font-family: 'Bebas Neue', cursive;}\nh2{ font-family: 'Rubik', sans-serif;}\np {\n  font-family: 'Rubik', sans-serif;\n}\na {\n  font-family: 'Rubik', sans-serif;\n}\n.seeMore{font-size: 27px ;\n  font-family: 'Bebas Neue', cursive;\ncolor:#FFF;\nbackground: #000;\nborder-radius: 3px;\npadding: 3px 51px; width: fit-content;\nwidth: fit-content;\nmargin: 5% auto 0 auto;\ncursor: help;\ntext-decoration: none;}\n\n\n.gridbox {\n    text-align: center;\n    max-width: 100%;\n    margin: 0 auto;\n    padding: 0 5%;\n\n  }\n  \n  .cantv{cursor: pointer;}\n  .cantvWrap {\n      height: 55px;\n      color: rgba(0, 0, 0, 0.577);\n      width: 193px;\n      padding: 0!important;\n      margin: 0!important;   \n      line-height: 57px; \n      font-size: 15px;\n      font-family: 'Bebas Neue';\n       z-index: 999;\n       position: absolute;\n      \n    }\n\n  \n      .one {\n        background-color: rgb(255, 255, 255);\n        max-width: 655px;\n        width: -moz-fit-content;\n        width: fit-content;\n        /* margin-left: 3%; */\n        margin-top: 3%;\n        padding: 25px;\n        border-radius: 11px;\n        margin: 0 auto;}\n\n.head{background: rgba(233, 30, 172, 0.7);\n  backdrop-filter: blur(5px);\nmargin-top: 3%; right: 5%; max-width: 271px; padding: 29px; border-radius: 7px;}\n\na { text-decoration: none;cursor: pointer;}\n\n.back:hover{cursor: pointer;color: #000000; background: #ffffff;}\n.back{cursor: pointer;color: #FFF; background: #000;\npadding: 3px; width: 111px; margin-bottom: 9%;\npadding: 3%;}\n\n.mapImg{\n  max-width: 100%; height: auto;\n}\n\n.link{ padding: 10px 0; margin-top: 9px;}\n.link a{cursor: pointer; color: #FFF; background: #000; font-size: 15px;\npadding: 5px 15px;}\n.link a:hover{ color: #000000; background: #ffffff; font-size: 15px;\npadding: 5px 15px;}\n\n  /* Button Filters */\n  .button-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 13px;\n    margin: 5% auto 3% auto;\n    flex-direction: row;\n  }\n  .buttonFilter > button:hover{\n    \n    transition: all 1s ease;\n    color:rgba(0, 195, 255, 0.966)} \n\n #dark .buttonFilter button {color: #FFF}\n  .buttonFilter button {\n    height: 2rem;\n    padding: 0 1rem;\n    cursor: pointer;\n    border: none;\n    background: none;\n    color:rgb(0, 0, 0);\n    font-size: 17px;\n    \n  }\n  \n  .buttonFilter > button.active {\n    background: rgb(0, 0, 0);\n    color: white;\n    border-radius: 5px;\n    border-bottom: 1px solid #40f4fd;\n  }\n  \n  /* Image */\n\n.img-graph { \n  display: grid;\n  /* grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr)); */\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-top: 2rem;mix-blend-mode:multiply}\n\n\n  #dark .image-container {mix-blend-mode:multiply}\n\n  .image-container__two {\n    display: grid;\n    width: 80%;\n    margin: 0 auto 5% auto;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1rem;\n    margin-top: 2rem;mix-blend-mode:multiply\n    \n  }\n  .image-container {\n    display: grid;\n    /* grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr)); */\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1rem;\n    margin-top: 2rem;\n    /* mix-blend-mode:multiply */\n    background: #fff;\n    border-radius: 17px;\n  \n    padding: 3%;\n  }\n  .image-container > .image-card {\n    color: white;\n    border-radius: 5px;\n    position: relative;\n    height: auto;\n    width:auto;\n  }\n\n \n  \n  .image-card img:hover  {\n    transform:  scale(0.9);\n  }\n  .image-card img {\n    width: 100%;\n    \n    object-fit: cover;\n    transition: all 1s ease;\n  }\n\n\n\n  .image-card h2 {\n    position: relative;\n    bottom: 0;\n    left: 1rem;\n    font-size: 1rem;\n color: #000;\n margin-bottom: 33px;\n text-align: left;\n  }\n\n\n\n  \n  @media screen and (max-width: 971px) {\n    .cantvWrap { display: none }\n  }\n  \n  @media screen and (max-width:1301px) {\n    \n    .one{background-color: rgb(255, 255, 255);\n      max-width: 655px;\n      width: fit-content;\n      margin-left: 3%;\n      margin-top: 3%;\n      padding: 25px;\n      border-radius: 11px;} \n    }\n    @media screen and (max-width: 571px) {\n      .image-container {\n        grid-template-columns: repeat(1, 1fr);}\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
